import {
  GET_POSTS,
  POSTS_LOADED_FAIL,
  POSTS_LOADED_SUCCESS,
  GET_POST,
  POST_LOADED_SUCCESS,
  DELETE_POST
} from '../constants/constants'

export const PostReducer = (state, action) => {
  const { type, payload } = action
  switch (type) {
    case POSTS_LOADED_SUCCESS:
      return {
        ...state,
        posts: payload,
        postsLoading: false
      }
    case POSTS_LOADED_FAIL:
      return {
        ...state,
        posts: [],
        postsLoading: false
      }

    case POST_LOADED_SUCCESS:
      return {
        ...state,
        post: payload,
        postLoading: false
      }
    case POSTS_LOADED_FAIL:
      return {
        ...state,
        post: {},
        postLoading: false
      }
    case DELETE_POST:
      return {
        ...state,
        posts: state.posts.filter((post) => post._id !== payload)
      }
    case GET_POST:
      return [...state, payload.post]
    case GET_POSTS:
      return [...state, payload.posts]
    default:
      return state
  }
}
